// Layouts
import AnonymousLayout from "../layouts/AnonymousLayout";
import MainLayout from "../layouts/MainLayout";
import FixedLayout from "../layouts/FixedLayout";
import PlannerLayout from "../layouts/PlannerLayout";
import GridLayout from "../layouts/GridLayout";

// Pages
import ChangePassword from "../pages/User/ChangePassword";
import Login from "../pages/User/Login";
import Home from "../pages/Home";
import App from "../App";
import User from "../pages/User/index"
import DataChange from "../pages/Datachanges/index"
import Fair from "../pages/Config/fairs"
import Classification from "../pages/Config/classifications"
import Contractorstatedef from "../pages/Config/contractorstatedef"
import Contractortradedef from "../pages/Config/contractortradedef"
import Contractornewmstatedef from "../pages/Config/contractornewmstatedef"
import ContractorCard from "../pages/Contractor/card"
import ContractorGroups from "../pages/Contractor/groups"
import Notes from "../pages/Contractor/notes"
import Contacts from "../pages/Contractor/contacts"
import Contractor from "../pages/Contractor/index"
import ContractorArchives from "../pages/Contractor/archives"
import Plans from "../pages/Plan/index"
import Standeditor from "../pages/Plan/standeditor"
import { renderRoutes } from "./generate-routes";
import Cardview from "../pages/Plan/cardview";
import CardEdit from "../pages/Plan/edit";
//import CreateUser from "../pages/CreateUser";
//import ListUsers from "../pages/ListUsers";
import OutgoingMail from "../pages/Email/outgoingmails"
import IncomingMail from "../pages/Email/incomingmails"

import ImportedMail from "../pages/Email/importedmails"
import { IncomingMessage } from "http";

export const routes = [
{
    layout: AnonymousLayout,
    
    routes: [
      {
        name: 'login',
        title: 'Login page',
        component: Login,
        path: '/login',
        
        isPublic: true,
      },
      {
        name: 'changepassword',
        title: 'Change password',
        component: ChangePassword,
        path: '/changepassword',
        
        isPublic: false,
      },

    ]
  },
  {
    layout: MainLayout,
    routes: [
      {
        name: 'test',
        title: 'Test page',
        component: App,
        path: '/test',
        
        isPublic: true,
      }
    ]
  },
  {
    layout: GridLayout,
    //layout:PlannerLayout,
    routes: [
      {
        name: 'home',
        title: 'Empty page',
        component: Home,
        path: '/',
        isPublic: false,
      },
      {
        name: 'users',
        title: 'Users page',
        component: User,
        path: '/users',
        isPublic: false,
      },
      {
        name: 'datachanges',
        title: 'Data changes page',
        component: DataChange,
        path: '/datachanges',
        isPublic: false,
      },
      {
        name: 'fairs',
        title: 'Fairs page',
        component: Fair,
        path: '/fairs',
        isPublic: false,
      },

      {
        name: 'importedmails',
        title: 'Imported mail page',
        component: ImportedMail,
        path: '/mailbox/importedmails',
        isPublic: false,
      },


      {
        name: 'outgoingmails',
        title: 'Outgoing mail page',
        component: OutgoingMail,
        path: '/mailbox/outgoingmail',
        isPublic: false,
      },

      {
        name: 'incomingmails',
        title: 'Incoming mail page',
        component: IncomingMail,
        path: '/mailbox/incomingmail',
        isPublic: false,
      },

      {
        name: 'contractorstatedefs',
        title: 'Contractor state def page',
        component: Contractorstatedef,
        path: '/contractorstatedefs',
        isPublic: false,
      },
      {
        name: 'classifications',
        title: 'Classification page',
        component: Classification,
        path: '/classifications',
        isPublic: false,
      },
      {
        name: 'contractornewmstatedefs',
        title: 'Contractor state def page',
        component: Contractornewmstatedef,
        path: '/newmstatedefs',
        isPublic: false,
      },
      {
        name: 'contractors',
        title: 'Contractors page',
        component: Contractor,
        path: '/contractors',
        isPublic: false,
      },
      {
        name: 'archive_contractors',
        title: 'Contractors archive',
        component: ContractorArchives,
        path: '/contractors/archives',
        isPublic: false,
      },
      {
        name: 'card',
        title: 'Contractor card',
        component: ContractorCard,
        path: '/contractors/card/:id',
        isPublic: false,
      },
      
      {
        name: 'contractortradedefs',
        title: 'Contractor trade def page',
        component: Contractortradedef,
        path: '/contractortradedefs',
        isPublic: false,
      },
      {
        name: 'contractorgroups',
        title: 'Contractor groups page',
        component: ContractorGroups,
        path: '/contractorgroups',
        isPublic: false,
      },
      {
        name: 'contacts',
        title: 'Contacts page',
        component: Contacts,
        path: '/contacts',
        isPublic: false,
      },
      {
        name: 'notes',
        title: 'Notes page',
        component: Notes,
        path: '/notes',
        isPublic: false,
      },
      {
        name: 'plans',
        title: 'Plans page',
        component: Plans,
        path: '/plans',
        isPublic: false,
      },
      {
        name: 'technicalcard',
        title: 'Technical card',
        component: CardEdit,
        path: '/plans/edit/:id',
        isPublic: false,
      },
      
    ]
    },
    
{
    layout: PlannerLayout,
    routes: [
      {
        name: 'standeditor',
        title: 'Standeditor page',
        component: Standeditor,
        path: '/plans/standeditor/:id',
        isPublic:false,
      },
      {
        name: 'cardview',
        title: 'Card page',
        component: Cardview,
        path: '/plans/cardview/:id',
        isPublic:false,
      },
      {
        name: 'tcardview',
        title: 'Card page',
        component: Cardview,
        path: '/plans/tcardview/:id',
        isPublic:true,
      },
      
      /*{
        name: 'users',
        title: 'Users',
        hasSiderLink: true,
        routes: [
          {
            name: 'list-users',
            title: 'List of users',
            hasSiderLink: true,
            component: ListUsers,
            path: '/users'
          },
          {
            name: 'create-user',
            title: 'Add user',
            hasSiderLink: true,
            component: CreateUser,
            path: '/users/new'
          }
        ]
      }*/
    ]
  }
];

export const Routes = renderRoutes(routes);